<script setup lang="ts">

import TextSelector from "@/pages/Settings/AppConfigurationPage/components/TextSelector.vue";
import ConfigurationSectionRow from "@/pages/Settings/AppConfigurationPage/components/ConfigurationSectionRow.vue";
</script>

<template>
  <v-card flat color="grey-lighten-4">
    <v-card-title>
      {{ $t("components.GeneralAppConfigurationForm.title") }}
    </v-card-title>
    <v-card-subtitle>
      Set the general application settings below.
    </v-card-subtitle>
    <v-divider class="my-2"/>
    <v-card-text>
      <configuration-section-row>
        <template #name>
          {{ $t('components.GeneralAppConfigurationForm.app_name') }}
        </template>

        <text-selector
          variant="outlined"
          density="compact"
          :label="$t('components.AppConfigurationPage.app_name')"
          config-key="appName"
        />
      </configuration-section-row>
      <configuration-section-row >
        <template #name>
          {{ $t('components.GeneralAppConfigurationForm.support_email') }}
        </template>
        <template #comment>
          Shown in help dialogs and support sections
        </template>

        <text-selector
          variant="outlined"
          density="compact"
          :label="$t('components.AppConfigurationPage.support_email')"
          config-key="supportEmail"
        />
      </configuration-section-row>
      <configuration-section-row :show-divider="false">
        <template #name>
          {{ $t('components.GeneralAppConfigurationForm.app_url') }}
        </template>
        <template #comment>
          The frontend application URL
        </template>

        <text-selector
          variant="outlined"
          density="compact"
          :label="$t('components.GeneralAppConfigurationForm.app_url')"
          config-key="appUrl"
        />
      </configuration-section-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>
